import { render } from "./RegistrationView.vue?vue&type=template&id=739f45b6&ts=true"
import script from "./RegistrationView.vue?vue&type=script&lang=ts"
export * from "./RegistrationView.vue?vue&type=script&lang=ts"

import "./RegistrationView.vue?vue&type=style&index=0&id=739f45b6&lang=scss"

import exportComponent from "/builds/likeacoffee.com/time-assistantv3-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__